import { useState } from "react";
import { PayButtons } from "@/components/PayButtons";
import { LISTINO, IVA, tierForWeight } from "@/lib/brand";
import { eur } from "@/lib/api";
import { Input } from "@/components/ui/input";

const Estimator = () => {
  const [kg, setKg] = useState("");
  const tier = tierForWeight(kg);
  return (
    <div className="rounded-3xl bg-[#0D3B52] text-white p-8 relative overflow-hidden grain">
      <p className="text-[11px] uppercase tracking-[0.22em] text-[#D4AF37] font-semibold">Calcola il preventivo</p>
      <p className="font-display text-2xl mt-2">Quanto pesa il tuo animale?</p>
      <div className="flex items-center gap-3 mt-6">
        <Input data-testid="estimator-weight-input" type="number" min="0" step="0.1" value={kg} onChange={(e) => setKg(e.target.value)}
          placeholder="es. 12" className="bg-white/10 border-white/20 text-white placeholder:text-white/50 h-12 text-lg" />
        <span className="text-white/70">kg</span>
      </div>
      <div className="mt-8 min-h-[92px]" data-testid="estimator-result">
        {tier && tier.price && (
          <>
            <p className="text-sm text-white/70">{tier.label} · {tier.range}</p>
            <p className="font-display text-5xl font-semibold text-[#F4E8C1] mt-1">{eur(tier.price)} <span className="text-lg text-white/70 font-sans">+ IVA</span></p>
            <p className="text-xs text-white/60 mt-1">Totale IVA {IVA}% inclusa: {eur(tier.price * (1 + IVA / 100))}</p>
            <p className="text-xs text-white/60 mt-1">Con Klarna in 3 rate (+6% commissioni): {eur(tier.price * (1 + IVA / 100) * 1.06)}</p>
            <div className="mt-4"><PayButtons lookupKey={`singola_${tier.id}`} amount={tier.price * (1 + IVA / 100)} compact testid="listino-pay" /></div>
            <p className="text-[11px] text-white/50 mt-2">Pagamento sicuro con Stripe. Il prezzo è per cremazione singola; eventuali maggiorazioni festive verranno concordate.</p>
          </>
        )}
        {tier && !tier.price && <p className="font-display text-3xl text-[#F4E8C1]">Preventivo personalizzato — contattaci</p>}
        {!tier && <p className="text-sm text-white/60">Inserisci il peso indicativo per vedere il prezzo della cremazione singola.</p>}
      </div>
    </div>
  );
};

export const Listino = () => (
  <section id="listino" className="py-20 lg:py-28">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-12">
      <div className="lg:col-span-7">
        <p className="text-[11px] uppercase tracking-[0.28em] text-[#997316] font-semibold">Listino 2026</p>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold text-[#0D3B52] mt-3">Cremazione singola</h2>
        <p className="text-sm text-[#5C6B73] mt-3">Prezzi IVA esclusa. Categoria animale indicativa in base al peso. Domeniche, festivi e ritiri notturni: +€150 + IVA. Pagamento anche con Klarna in 3 rate (+6% commissioni).</p>
        <div className="mt-10 divide-y divide-[#E2DDD5] border-y border-[#E2DDD5]" data-testid="price-list">
          {LISTINO.map((t) => (
            <div key={t.id} className="flex items-center justify-between py-5 group">
              <div>
                <p className="font-display text-xl font-semibold text-[#0D3B52] group-hover:text-[#B8860B] transition-colors">{t.label}</p>
                <p className="text-sm text-[#5C6B73]">{t.range}</p>
              </div>
              <p className="text-right" data-testid={`price-${t.id}`}>
                {t.price ? (<><span className="font-display text-3xl font-semibold text-[#0D3B52]">{eur(t.price)}</span><span className="block text-xs text-[#997316] font-semibold">+ IVA</span></>)
                  : <span className="text-sm font-semibold text-[#997316]">Preventivo personalizzato</span>}
              </p>
            </div>
          ))}
        </div>
      </div>
      <div className="lg:col-span-5 lg:pt-24">
        <Estimator />
      </div>
    </div>
  </section>
);
